import React from 'react'
import { useWindowDimensions, View } from 'react-native'
import { TooltipProps, useCopilot } from 'react-native-copilot'
import { StyleService, useStyleSheet } from '@style/service'
import { getAnchoredStepByTargetId, getStepIndexById, steps } from './steps'
import { NoraHomeWalkthroughCard } from './NoraHomeWalkthroughCard'
import { useNoraHomeWalkthroughContext } from './NoraHomeWalkthroughContext'
import { getNoraHomeWalkthroughLayout } from './NoraHomeWalkthroughLayout'
import { NoraHomeWalkthroughTargetId } from './types'

export const NoraHomeCopilotTooltip = ({ placement }: TooltipProps) => {
  const windowDimensions = useWindowDimensions()
  const styles = useStyleSheet(themedStyles)
  const { currentStep, goToNext, isLastStep, stop } = useCopilot()
  const context = useNoraHomeWalkthroughContext()
  const step = currentStep ? getAnchoredStepByTargetId(currentStep.name) : undefined

  if (!context || !step) {
    return null
  }

  const stepIndex = getStepIndexById(step.id)
  const layout = getNoraHomeWalkthroughLayout(windowDimensions)
  const isSettingsStep = step.targetId === NoraHomeWalkthroughTargetId.Settings
  const tooltipStepStyle = isSettingsStep ? styles.settingsTooltip : styles.centeredTooltip
  const arrowStepStyle = isSettingsStep ? styles.settingsArrow : undefined

  const handleNext = async () => {
    if (isLastStep) {
      await context.showFinalStep(stop)
      return
    }

    await goToNext()
  }

  return (
    <View style={[styles.tooltip, tooltipStepStyle]} testID="nora-home-walkthrough-copilot-tooltip">
      <NoraHomeWalkthroughCard
        step={step}
        stepIndex={stepIndex}
        stepCount={steps.length}
        layout={layout}
        arrowPlacement={placement === 'top' ? 'bottom' : 'top'}
        arrowStyle={arrowStepStyle}
        onClose={context.close}
        onNext={handleNext}
      />
    </View>
  )
}

const themedStyles = StyleService.create({
  tooltip: {
    alignItems: 'center',
    width: '100%',
  },
  centeredTooltip: {
    alignItems: 'center',
    paddingHorizontal: 16,
  },
  settingsTooltip: {
    alignItems: 'flex-end',
    paddingRight: 12,
  },
  settingsArrow: {
    alignSelf: 'flex-end',
    marginRight: 10,
  },
})
